import { useContext, useEffect, useRef, useState } from "react";
import SetHumidity from "../../constants/SetHumidity";
import HumidityChanges from "../../constants/HumidityChange";
import { Context } from "../../context/Context";
import ForeignScenarios from "../../constants/ForeignScenario";

const ForeignScenarioModal = ({
  setForeignScenarioModal,
  foreignScenario,
  handleForeignScenarioLearnCodeModal,
  foreignScenarioNumber,
  setForeignScenarioNumber,
  handleAssignForeignScenario,
}) => {
  const { scenarioCommands, devices } = useContext(Context);
  const [selectedType, setSelectedType] = useState(0);
  const [selectedOutputName, setSelectedOutputName] = useState(1);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setForeignScenarioModal(modalName);
  }, []);

  const renderOptionsOfScenarioType = () => {
    if (!foreignScenario) return;
    let commands = scenarioCommands.filter(
      (cmd) => cmd.scenario_id == foreignScenario.id,
    );
    if (!commands.length) return;
    let device = devices.find((d) => d.id == commands[0].device_id);
    if (!device) {
      return;
    }
    const foreignScenarioData = ForeignScenarios.find(
      (item) => item.device_type == device.type,
    );
    if (foreignScenarioData) {
      return Object.keys(foreignScenarioData.scenario_type).map((type) => (
        <option key={type} value={type ?? ""}>
          {foreignScenarioData.scenario_type[type]}
        </option>
      ));
    }
    return null; // Return null if no matching data is found
  };

  const renderOptionsOfScenarioNumber = () => {
    if (!foreignScenario) return;
    let commands = scenarioCommands.filter(
      (cmd) => cmd.scenario_id == foreignScenario.id,
    );
    if (!commands.length) return;
    let device = devices.find((d) => d.id == commands[0].device_id);
    if (!device) {
      return;
    }
    const foreignScenarioData = ForeignScenarios.find(
      (item) => item.device_type == device.type,
    );

    if (foreignScenarioData) {
      return Object.keys(foreignScenarioData.scenario_num[selectedType]).map(
        (item) => {
          return (
            <option
              key={foreignScenarioData.scenario_num[selectedType][item].value}
              value={
                foreignScenarioData.scenario_num[selectedType][item].value ?? ""
              }
            >
              {foreignScenarioData.scenario_num[selectedType][item].name}
            </option>
          );
        },
      );
    }

    return null; // Return null if no matching data is found
  };

  const handleSubmit = () => {
    let commands = scenarioCommands.filter(
      (cmd) => cmd.scenario_id == foreignScenario.id,
    );
    if (!commands.length) return;
    let device = devices.find((d) => d.id == commands[0].device_id);
    if (!device) {
      return;
    }
    if (device.type == 3) {
      handleForeignScenarioLearnCodeModal();
    } else {
      const foreignScenarioData = ForeignScenarios.find(
        (item) => item.device_type == device.type,
      );
      handleAssignForeignScenario(
        foreignScenario,
        foreignScenarioData.scenario_type[selectedType],
        selectedOutputName,
      );
    }
    closeButton.current.click();
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="ForeignScenarioModal"
      tabIndex="-1"
      aria-labelledby="ForeignScenarioModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              انتخاب ورودی
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-sm-12 col-md-6">
                <div className="mb-3">
                  <select
                    id="timerSelect"
                    className="form-select w-100"
                    data-style="btn-default"
                    value={selectedType}
                    onChange={(e) => setSelectedType(e.target.value)}
                  >
                    {renderOptionsOfScenarioType()}
                  </select>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                <div className="mb-3">
                  <select
                    id="timerSelect"
                    className="form-select w-100"
                    data-style="btn-default"
                    value={foreignScenarioNumber}
                    onChange={(e) => {
                      setSelectedOutputName(
                        e.nativeEvent.target[e.nativeEvent.target.selectedIndex]
                          .text,
                      );
                      setForeignScenarioNumber(e.target.value);
                    }}
                  >
                    {renderOptionsOfScenarioNumber()}
                  </select>
                </div>
              </div>
            </div>
            <div>
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleSubmit}
            >
              ثبت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForeignScenarioModal;
